import React from "react";
import { withRouter } from "react-router-dom";
import { useQuery } from "react-apollo-hooks";
import { INQUIRY_CONFIG_QUERY } from "../Queries";
import Presenter from "./Presenter";

export default withRouter(({ history, match }) => {
  const { data, loading } = useQuery(INQUIRY_CONFIG_QUERY);

  if (loading === true) {
    return (
      <div className="panel-loader">
        <span className="spinner-small"></span>
      </div>
    );
  } else if (!loading && data && data.AdminInquiryConfig) {
    const {
      AdminInquiryConfig: { id, name, manager, listCount, pageCount }
    } = data;
    return (
      <Presenter
        history={history}
        match={match}
        id={id}
        name={name}
        manager={manager}
        listCount={listCount}
        pageCount={pageCount}
      ></Presenter>
    );
  }
});
